import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import First from "./component/First";
import Second from "./component/Second";
import Third from "./component/Third";
import Forth from "./component/Forth";
import Fifth from "./component/Fifth";
import Sixth from "./component/Sixth";
import Seventh from "./component/Seventh";
import Eighth from "./component/Eighth";
import Ninth from "./component/Ninth";
import Tenth from "./component/Tenth";
import Eleventh from "./component/Eleventh";
import Twelth from "./component/Twelth";
import Thirteen from "./Thirteen";
import Fourteen from "./component/Fourteen";
import Fifteen from "./component/Fifteen";
import Chat from "./component/Chat";
import Sixteen from "./component/Sixteen";
import Footer from "./component/Footer";

export default class App extends Component {
  render() {
    return (
      <>
        <First />
        <Second />
        <Third />
        <Forth />
        <Fifth />
        <Sixth />
        <Seventh />
        <Eighth />
        <Ninth />
        <Tenth />
        <Eleventh />
        <Twelth />
        <Thirteen />
        <Fourteen />
        <Fifteen />
        <Sixteen />
        <Footer />
        <Chat />
      </>
    );
  }
}
